import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserData } from '../../services/api';

export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserData();
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.status,
        message:  error?.message || "Something went wrong at Server Side"
      });
    }
  }
);

const initialState = {
  userData: null,
  loading: false,
  error: null,
  noAccess: false,
  errorCode: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserData: (state) => {
      state.userData = null;
      state.loading = false;
      state.error = null;
      state.noAccess = false;
      localStorage.removeItem('userType');
    },
    setSelectedUserType: (state, action) => {
      if (state.userData) {
        const userType = state.userData.userTypes.find(type => type.userTypeId === action.payload);
        if (userType) {
          localStorage.setItem('userType', userType.userTypeId === 1 ? 'internal' : 'external');
        }
      }
    },
    setNoAccess: (state, action) => {
      state.noAccess = action.payload.noAccess;
      state.errorCode = action.payload.errorCode;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.noAccess = false;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
        state.error = null;
        state.noAccess = false;

        // If user has only one type, automatically select it
        if (action.payload.userTypes?.length === 1) {
          const userType = action.payload.userTypes[0];
          localStorage.setItem('userType', userType.userTypeId === 1 ? 'internal' : 'external');
          localStorage.setItem("userTypeId",userType.userTypeId)
        }
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || { message: 'An unknown error occurred' };
        localStorage.removeItem('userType');
      });
  },
});

export const { clearUserData, setSelectedUserType, setNoAccess } = userSlice.actions;
export default userSlice.reducer;
